import { useColors } from '@/core/domain/people/Colors/Colors.hooks';
import { Color } from '@/core/domain/people/Colors/Colors.types';
import { Select, SelectProps } from 'antd';
import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  onSelectedColor?: (color: Color) => void;
}

const VehicleColorsSelect = forwardRef<BaseSelectRef, SelectProps & Props>(
  (props, ref) => {
    const intl = useIntl().formatMessage;

    const { data: colorsData, isLoading } = useColors();

    return (
      <Select
        {...props}
        ref={ref}
        showSearch
        optionFilterProp="label"
        onSelect={(value: number) => {
          const color = colorsData?.data.find((color) => color.id === value);

          if (!!props.onSelectedColor && !!color) {
            props.onSelectedColor(color);
          }
        }}
        loading={isLoading}
        options={colorsData?.data.map((color) => ({
          value: color.id,
          label: intl({ id: `customers.domain.vehicle.${color.name}` }),
        }))}
      />
    );
  },
);

export default VehicleColorsSelect;
